import React, { useState } from "react";

// Sample data array
const data = [
  {
    id: 1,
    title: "ஆரோக்கியம்: ஆவின் பால் விலைக்கு மாற்றங்கள்",
    
    description:
      "பால் விலையில் ஏற்ற இறக்கங்கள் குடும்பங்களின் பொருளாதாரத்தை பாதிக்கின்றன. பால் விலையில் ஏற்ற இறக்கங்கள் குடும்பங்களின் பொருளாதாரத்தை பாதிக்கின்றன.",
  },
  {
    id: 2,
    title: "சர்க்கரை நோயாளிகளுக்கு எளிய குறிப்புகள்",
    description: "சர்க்கரை நோயாளிகளுக்கு தினசரி உணவில் தவிர்க்க வேண்டிய உணவுகள்.",
  },
  {
    id: 3,
    title: "வீட்டு மருத்துவக் குறிப்புகள்",
    description: "வீட்டில் அன்றாட பயன்படுத்தும் பொருட்களின் மருத்துவ குணங்கள்.",
  },
];

export default function Search() {
  const [searchInput, setSearchInput] = useState("");
  const [results, setResults] = useState(data);

  // Filter results based on search input
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    const filteredResults = data.filter(
      (item) =>
        item.title.includes(value) || item.description.includes(value)
    );
    setResults(filteredResults);
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      {/* Navigation bar with search */}
      <nav
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 20px",
          backgroundColor: "#007BFF",
          color: "#fff",
        }}
      >
        <h1 style={{ margin: 0 }}>Article Search</h1>

        <input
          type="text"
          placeholder="Search..."
          value={searchInput}
          onChange={handleSearch}
          style={{
            padding: "8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            width: "250px",
          }}
        />
      </nav>

      {/* Search results displayed below the navbar */}
      <div style={{ marginTop: "20px" }}>
        {results.length > 0 ? (
          results.map((item) => (
            <div
              key={item.id}
              style={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: "15px",
                marginBottom: "10px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              }}
            >
              <h3 style={{ margin: "0 0 10px" }}>{item.title}</h3>
              <p style={{ margin: "0", color: "#555" }}>{item.description}</p>
            </div>
          ))
        ) : (
          <p>No results found</p>
        )}
      </div>
    </div>
  );
}